import { render } from "./FormDeliver.vue?vue&type=template&id=0a376ae8&ts=true"
import script from "./FormDeliver.vue?vue&type=script&lang=ts"
export * from "./FormDeliver.vue?vue&type=script&lang=ts"

import "./FormDeliver.vue?vue&type=style&index=0&id=0a376ae8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__